import React from 'react';
import { Navigate, useNavigate } from 'react-router';
import { useApptekster } from '../../contexts/ApptekstContext';
import { HotjarMaskert } from '../../components/HotjarMaskert';
import { Paragraph } from '../../components/Paragraph';
import { SVVBreadcrumbLink } from '@komponentkassen/svv-breadcrumbs';
import { useKnytningState } from './KnyttSkilt';
import { SVVLayoutBanner } from '@komponentkassen/svv-layout';
import { SVVButton } from '@komponentkassen/svv-button';

export const KnytningBekreftelse: React.FC = () => {
    const t = useApptekster();
    const navigate = useNavigate();
    const knytning = useKnytningState((state) => state.knytning);
    const kjennemerke = useKnytningState((state) => state.kjennemerke);
    const tegnkombinasjon = useKnytningState((state) => state.tegnkombinasjon);
    const kjoretoy = useKnytningState((state) => state.kjoretoy);

    if (!tegnkombinasjon) {
        return <Navigate to={'/statusoversikt'} />;
    }

    return (
        <>
            <SVVLayoutBanner>
                <SVVBreadcrumbLink
                    href="#/statusoversikt"
                    ariaLabel={t('personlig-kjennemerke.snarvei.status')}
                    className="intern-link"
                >
                    {t('personlig-kjennemerke.snarvei.status')}
                </SVVBreadcrumbLink>
                <h1>
                    {t('personlig-kjennemerke.knytt.bekreftelse.overskrift')}{' '}
                    <HotjarMaskert>{tegnkombinasjon}</HotjarMaskert>
                </h1>
            </SVVLayoutBanner>

            <SVVLayoutBanner secondary>
                <h2 className="spacing-bottom--medium">
                    {t(
                        'personlig-kjennemerke.knytt.bekreftelse.underoverskrift',
                    )}
                </h2>
                <Paragraph className="spacing-bottom--xxsmall">
                    <strong>
                        {t('personlig-kjennemerke.knytt.bekreftelse.dato')}
                    </strong>{' '}
                    <HotjarMaskert>{knytning?.dato}</HotjarMaskert>
                </Paragraph>
                <Paragraph className="spacing-bottom--xxsmall">
                    <strong>
                        {t(
                            'personlig-kjennemerke.knytt.bekreftelse.klokkeslett',
                        )}
                    </strong>{' '}
                    <HotjarMaskert>{knytning?.klokkeslett}</HotjarMaskert>
                </Paragraph>

                <Paragraph>
                    {t('personlig-kjennemerke.knytt.bekreftelse.del1')}{' '}
                    <strong>
                        <HotjarMaskert>{tegnkombinasjon}</HotjarMaskert>
                    </strong>{' '}
                    {t('personlig-kjennemerke.knytt.bekreftelse.del2')}{' '}
                    <strong>
                        <HotjarMaskert>
                            {kjennemerke} ({kjoretoy?.merkenavn}{' '}
                            {kjoretoy?.modell})
                        </HotjarMaskert>
                    </strong>{' '}
                    {t('personlig-kjennemerke.knytt.bekreftelse.del3')}
                </Paragraph>
                <Paragraph>
                    {t(
                        'personlig-kjennemerke.knytt.bekreftelse.hva-skjer-videre',
                    )}
                </Paragraph>
                <SVVButton
                    onClick={() => navigate(`/status/${tegnkombinasjon}`)}
                >
                    {t('personlig-kjennemerke.delt.til-statusoversikten')}
                </SVVButton>
            </SVVLayoutBanner>
        </>
    );
};
